import type { BeneficialOwnerResponse } from '@gcv/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { BeneficialOwnerApi } from 'api';
import { BANK_BENEFICIAL_OWNERS_KEY } from 'tanstack-hooks/keys';

export function useBankUpdateBeneficialOwnerArchiveStatus(bankId: string, dispensaryId: string) {
  const beneficialOwnerApi = new BeneficialOwnerApi();
  const queryClient = useQueryClient();

  const { mutate: updateBeneficialOwnerArchiveStatus, isPending: isUpdatingBeneficialOwnerArchiveStatus } =
    useMutation({
      mutationKey: [BANK_BENEFICIAL_OWNERS_KEY, bankId, dispensaryId],
      mutationFn: ({ beneficialOwnerId, archived }: { beneficialOwnerId: string; archived: boolean }) =>
        beneficialOwnerApi.bankUpdateBeneficialOwnerArchiveStatus(
          bankId,
          dispensaryId,
          beneficialOwnerId,
          archived
        ),
      onSuccess: (updatedOwner) => {
        return queryClient.setQueryData(
          [BANK_BENEFICIAL_OWNERS_KEY, bankId, dispensaryId],
          (old: BeneficialOwnerResponse[] | undefined) =>
            old?.map((owner) => (owner.id === updatedOwner.id ? updatedOwner : owner))
        );
      },
      meta: {
        snackbarSuccessMessage: 'Beneficial owner archive status updated successfully.',
        snackbarErrorMessage: 'There was an issue updating beneficial owner archive status.'
      }
    });

  return { updateBeneficialOwnerArchiveStatus, isUpdatingBeneficialOwnerArchiveStatus };
}
